/* Just Tattoos — marquee helpers (progressive enhancement).
   Drives the mobile reviews carousel (dots + prev/next). The desktop marquee
   rows and the shop-by-style marquee are pure CSS. */
(function () {
  'use strict';

  if (window.__jtMarquee) return;
  window.__jtMarquee = true;

  function initCarousel(root) {
    var scroller = root.querySelector('.reviews__scroller');
    var dotsWrap = root.querySelector('[data-reviews-dots]');
    if (!scroller || !dotsWrap) return;
    var slides = scroller.querySelectorAll('[data-review-slide]');
    var controls = root.querySelector('.reviews__controls');
    if (slides.length < 2) {
      if (controls) controls.hidden = true;
      return;
    }

    var dots = [];
    function makeDot(i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'reviews__dot';
      b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      b.addEventListener('click', function () { scrollTo(i); });
      dotsWrap.appendChild(b);
      dots.push(b);
    }
    for (var i = 0; i < slides.length; i++) makeDot(i);

    function setActive(index) {
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === index);
    }

    function currentIndex() {
      var mid = scroller.scrollLeft + scroller.clientWidth / 2;
      var best = 0;
      var bestDist = Infinity;
      for (var s = 0; s < slides.length; s++) {
        var center = slides[s].offsetLeft - scroller.offsetLeft + slides[s].offsetWidth / 2;
        var dist = Math.abs(center - mid);
        if (dist < bestDist) { bestDist = dist; best = s; }
      }
      return best;
    }

    function scrollTo(index) {
      index = (index + slides.length) % slides.length;
      var left = slides[index].offsetLeft - scroller.offsetLeft;
      if (scroller.scrollTo) {
        scroller.scrollTo({ left: left, behavior: 'smooth' });
      } else {
        scroller.scrollLeft = left;
      }
      setActive(index);
    }

    var prev = root.querySelector('[data-reviews-prev]');
    var next = root.querySelector('[data-reviews-next]');
    if (prev) prev.addEventListener('click', function () { scrollTo(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { scrollTo(currentIndex() + 1); });

    var raf = null;
    scroller.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = null;
        setActive(currentIndex());
      });
    }, { passive: true });

    setActive(0);
  }

  function init() {
    var carousels = document.querySelectorAll('[data-reviews-carousel]');
    for (var i = 0; i < carousels.length; i++) initCarousel(carousels[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
